import { ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';

type SnackbarWrapperProps = {
  children: ReactNode;
};

function SnackbarWrapper({ children }: SnackbarWrapperProps) {
  return (
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={4000}
      preventDuplicate
      dense
    >
      {children}
    </SnackbarProvider>
  );
}

export default SnackbarWrapper;
